const EMPTY = { name: "", norm: "", supplier: "", density_kg_m3: "7850", cost_per_kg: "", scrap_pct: "15", surcharge_pct: "0", thicknesses_mm: "" };

export function materialFormValues(material) {
  if (!material) return { ...EMPTY };
  return {
    ...Object.fromEntries(Object.keys(EMPTY).filter(key => key !== "thicknesses_mm").map(key => [key, material[key] == null ? "" : String(material[key])])),
    thicknesses_mm: (material.thicknesses_mm || []).map(t => String(t).replace(".", ",")).join("; "),
  };
}

function numberValue(value, label, positive = false) {
  const text = String(value ?? "").trim();
  if (!/^-?(?:\d+(?:[.,]\d*)?|[.,]\d+)$/.test(text)) throw new Error(`${label}: inserisci un numero valido (virgola ammessa).`);
  const number = Number(text.replace(",", "."));
  if (!Number.isFinite(number) || (positive ? number <= 0 : number < 0)) throw new Error(`${label}: inserisci un numero ${positive ? "maggiore di zero" : "maggiore o uguale a zero"}.`);
  return number;
}

export function materialPayload(form, { editing = false } = {}) {
  const name = String(form.name || "").trim();
  if (!name) throw new Error("Il nome del materiale è obbligatorio.");
  const thicknesses = String(form.thicknesses_mm || "").trim();
  const payload = {
    name,
    norm: String(form.norm || "").trim(),
    supplier: String(form.supplier || "").trim(),
    density_kg_m3: numberValue(form.density_kg_m3, "Densità", true),
    scrap_pct: numberValue(form.scrap_pct, "Sfrido"),
    surcharge_pct: numberValue(form.surcharge_pct, "Maggiorazione d'acquisto"),
    thicknesses_mm: thicknesses ? [...new Set(thicknesses.split(/[;\s]+/).filter(Boolean).map(t => numberValue(t, "Spessore", true)))].sort((a, b) => a - b) : [],
  };
  // Existing prices use their dedicated endpoint, which records price history.
  if (!editing) payload.cost_per_kg = String(form.cost_per_kg || "").trim() === "" ? null : numberValue(form.cost_per_kg, "Prezzo €/kg", true);
  return payload;
}
